import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  return {
    sidebarItem: _objectSpread(_objectSpread(_objectSpread({
      borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.borderColor),
      borderBottom: "".concat(componentTheme.bottomBorderWidth, " solid ").concat(componentTheme.bottomBorderColor),
      '&:hover': {
        borderRight: "".concat(componentTheme.hoverBorderWidth, " solid ").concat(componentTheme.hoverBorderColor)
      },
      padding: componentTheme.sidebarIsOpenPadding
    }, props.inStimulus && {
      borderBottom: 'none'
    }), props.sidebarOpen && props.inStimulus && {
      marginLeft: '10%'
    }), !props.sidebarOpen && {
      padding: "".concat(componentTheme.sidebarClosedPadding, " 0"),
      margin: "0 ".concat(componentTheme.sidebarClosedMargin),
      textAlign: 'center'
    }),
    infoHeader: {
      fontSize: componentTheme.infoHeaderFontSize,
      display: 'flex',
      color: componentTheme.infoHeaderColor
    },
    interactionType: {
      width: '60%'
    },
    pointsPossible: {
      width: '40%'
    },
    displayNumber: {
      color: componentTheme.darkTextColor,
      fontSize: componentTheme.numberFontSize,
      fontWeight: componentTheme.numberFontWeight
    },
    itemBody: {
      fontSize: componentTheme.itemBodyFontSize,
      color: componentTheme.darkTextColor,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      marginTop: componentTheme.itemBodyMarginTop
    },
    mainText: _objectSpread({
      position: 'relative',
      cursor: 'pointer'
    }, props.sidebarOpen && {
      fontSize: componentTheme.sidebarIsOpenMainTextFontSize,
      marginTop: componentTheme.mainTextPaddingTop
    }),
    pinWrapper: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  };
};
export default generateStyle;